/**
 * Rewards a child has claimed that a grown-up still has to hand over (Jens 2026-10-11).
 * Oldest claim first, so nothing waits forever at the bottom.
 */
export function rewardsToHandOver<T extends { is_claimed?: boolean; handed_over_at?: unknown; claimed_at?: unknown }>(
  rewards: T[] | null | undefined,
): T[] {
  const time = (v: unknown) => {
    const ms = v ? new Date(v as any).getTime() : NaN;
    return Number.isNaN(ms) ? 0 : ms;
  };
  return (rewards || [])
    .filter((r) => r.is_claimed && !r.handed_over_at)
    .sort((a, b) => time(a.claimed_at) - time(b.claimed_at));
}
